import type { Observable } from 'rxjs'
import { catchError, throwError } from 'rxjs'
import { concat, of } from 'rxjs'
import { v4 as uuidv4 } from 'uuid'
import type { Action } from '@reduxjs/toolkit'
import { addBlockingRequest, removeBlockingRequest } from '../../Slice/Application/ApplicationSlice.js'

/**
 * Wraps an observable operation with addBlockingRequest and removeBlockingRequest.
 *
 * @param operation$ - The long-running observable operation.
 * @param title - Title for the blocking request popup.
 * @param message - Message for the blocking request popup.
 * @param id optional id if a fixed id is desired
 * @returns An observable that includes the blocking request lifecycle.
 */
export const withBlockingRequest = (operation$: Observable<Action>, title: string, message: string, id?: string): Observable<Action> => {
  const blockingId = id ?? uuidv4()

  return concat(
    of(addBlockingRequest({ title, message, id: blockingId })),
    operation$.pipe(
      catchError((error) =>
        concat(
          of(removeBlockingRequest(blockingId)),
          throwError(() => error)
        )
      )
    ),
    of(removeBlockingRequest(blockingId))
  )
}
